import React from 'react'

import { Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    title: {
      margin: theme.spacing(3, 0, 0, -1),
    },
    text: {
      backgroundColor: "white",
      color: theme.palette.black.main,
      padding: theme.spacing(0, 1),
      width:"fit-content",
      borderRadius: "5px",
      fontWeight: "bold",
    }
}))

const TitlePageUser = (props) => {
  const classes = useStyles()
  return (
    <section id="title-page">
      <Container className={classes.title}>
        <Typography variant="h5" gutterBottom className={classes.text}>
            {props.text}
        </Typography>
      </Container>
    </section>
  )
}

export default TitlePageUser
